module.exports = __webpack_public_path__ + "static/media/large-accent-more.e4fb07a6.svg";